export const API_URL = "https://api.sitikom.my.id";

/* =========================
   GET
========================= */
export async function apiFetch(url: string) {
  const token = localStorage.getItem("token");

  const res = await fetch(API_URL + url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    }
  });

  const data = await res.json();

  if (!res.ok || !data.success) {
    throw new Error(data?.message || "API error");
  }

  return data;
}

/* =========================
   POST
========================= */
export async function apiPost(url: string, body: any) {
  const token = localStorage.getItem("token");

  const res = await fetch(API_URL + url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: JSON.stringify(body)
  });

  const data = await res.json();

  if (!res.ok || !data.success) {
    throw new Error(data?.message || "Gagal menyimpan data");
  }

  return data;
}

/* =========================
   PUT  ✅ (BARU)
========================= */
export async function apiPut(url: string, body: any) {
  const token = localStorage.getItem("token");

  const res = await fetch(API_URL + url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: JSON.stringify(body)
  });

  const data = await res.json();

  if (!res.ok || !data.success) {
    throw new Error(data?.message || "Gagal memperbarui data");
  }

  return data;
}

/* =========================
   DELETE
========================= */
export async function apiDelete(url: string) {
  const token = localStorage.getItem("token");

  const res = await fetch(API_URL + url, {
    method: "DELETE",
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    }
  });

  const data = await res.json();

  if (!res.ok || !data.success) {
    throw new Error(data?.message || "Gagal menghapus data");
  }

  return data;
}
